<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>农行授权支付</span>
      <el-button class="but2">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">填写收款信息</span>
      </el-button>
      <el-form class="form" :model="payInfo" :rules="rules" ref="payInfo" label-width="180px">
        <el-row style="display: flex;flex-wrap:wrap; justify-content: left">
<!--          <el-col :span="10">-->
            <div class="leftBill">
              <el-form-item class="sp3" label="收款公司" prop="companyName">
                <el-input v-model="payInfo.companyName" readonly style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item class="sp3" label="交易日期">
                <el-input v-model="payInfo.orderDate" readonly style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item class="sp3" label="付款客户">
                <el-select v-model="selectedCustomerId" filterable placeholder="请选择付款客户" @change="customerChange" remote :remote-method="serverSearch" style="width: 300px" :disabled="disabledCus">
                  <el-option v-for="item in customersOption" :key="item.customer.id" :label="item.customer.name +' | '+item.customer.number" :value="item.customer.id"></el-option>
                </el-select>
                <el-button class="but4" type="primary" @click="selectCus">
                  <span class="sp4" v-if="!disabledCus">选择该客户扣款</span>
                  <span class="sp4" v-if="disabledCus">更换客户</span>
                </el-button>
              </el-form-item>
              <el-form-item class="sp3" label="签约信息">
                <el-select v-model="selectedSignInfoId" placeholder="请选择签约支付卡号" @change="cardChange" style="width: 300px" :disabled="disabledCard">
                  <el-option v-for="item in signInfoOption" :key="item.info" :label="item.info" :value="item.id"></el-option>
                </el-select>
                <el-button class="but4" type="primary" @click="selectCard">
                  <span class="sp4" v-if="!disabledCard">选择该卡扣款</span>
                  <span class="sp4" v-if="disabledCard">更换卡号</span>
                </el-button>
              </el-form-item>
              <el-form-item class="sp3" label="账户可用余额">
                <el-input v-model="payInfo.customerBalance" readonly style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item class="sp3" label="付款金额" prop="payAmount">
                <el-input v-model="payInfo.payAmount" style="width: 300px"></el-input>
              </el-form-item>
<!--              <el-form-item class="sp3" label="订单号(支付成功返回)">-->
<!--                <el-input v-model="payInfo.orderNo" readonly style="width: 300px"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item class="sp3" label="客户余额(支付成功更新)">
                <el-input v-model="payInfo.balance" readonly style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item style="margin-left: 70px">
                <el-button type="primary" @click="trustPay" style="font-weight: bold;" :loading="loading">确认信息并收款</el-button>
              </el-form-item>
            </div>
<!--          </el-col>-->
<!--          <el-col :span="14">-->
            <div class="rightBill">
              <span style="font-weight: 600;margin-top: 10px;">单据信息(可选中后，按票付款)</span>
              <el-divider class="div_right" style="border-width: 20px"></el-divider>
              <span v-if="selectedCustomerId !=='' && submitBillAmount.length === 0">该客户暂时没有未提票据</span>
              <el-checkbox-group v-model="selectBill" @change="changeBill">
                <el-checkbox class="checkbox" v-for="item in submitBillAmount" :label="item" :key="item.billNumber">
                  单据编号：{{item.billNumber}} 金额：{{item.TotalAmount}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
<!--          </el-col>-->
        </el-row>
      </el-form>
      <div class="note">
        <span style="margin-left: 40px">1、选择客户处输入客户姓名或客户姓名全拼首字母进行模糊查询；</span><br>
        <span style="margin-left: 40px">2、客户选择完成后，授权卡号及签约信息将会自动带出；</span><br>
        <span style="margin-left: 40px">3、若卡号信息未带出，请使用对应客户账号登录小禾订货平台选择“签约中心——授权支付签约”进行签约。</span>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {getBalanceAmount,getCustomersByCompany} from "../../../api/system/customer";
import {QuerySignRecord} from "../../../api/system/bank_abc";
import {abcTrustPay, getSubmitBillAmount} from "../../../api/system/pay";
import {mapGetters} from "vuex"

export default {
  data(){
    return {
      payInfo:{
        companyName:'',
        customerBalance:'',
        payAmount:'',
        orderNo:'',
        orderDate:'',
        balance:''
      },
      rules:{
        companyName:[
          { required: true , message:'无法获取您的所属财务组织信息' , trigger: 'blur'}
        ],
        customerBalance:[
          { required: true , message:'未查询到客户余额' , trigger: 'blur'}
        ],
        payAmount:[
          { required: true , message:'请输入付款金额' , trigger: 'change'}
        ]
      },
      selectedCustomerId:'',
      customersOption:[],
      signInfoOption:[],
      selectedSignInfoId:'',
      // customerIndex:0,
      payParamCustomerNumber:'',
      payParamCustomerName:'',
      signInfoIndex:0,
      submitBillAmount:[],
      selectBill:[],
      disabledCus:false,
      disabledCard:false,
      loading:false
    }
  },
  computed:{
    ...mapGetters(["currentUser"]),
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted(){
    this.refresh();
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    refresh(){
      this.payInfo.companyName = this.companyOrgs[this.index].name;
      //初始化客户列表
      this.serverSearch('')
      // let param = {};
      // param.companyId = this.companyOrgs[this.index].id;
      // this.queryCustomerAndBalance(param , false);

      //初始化当前日期
      let now = new Date();
      this.payInfo.orderDate = now.getFullYear() + '-'
        + (now.getMonth() + 1).toString().padStart(2,'0') + '-'
        + now.getDate().toString().padStart(2,'0')
    },
    /*
    * isDefault 是否设置默认选择
    * */
    queryCustomerAndBalance(param , isDefault){
      let _this = this;
      getCustomersByCompany(param).then(res => {
        _this.customersOption = res.data;
        if(!isDefault){
          return;
        }
        // 默认选择首个客户
        if(_this.customersOption.length > 0){
          this.selectedCustomerId = _this.customersOption[0].customer.id;
        }else{
          this.$message({
            message:"未查询到客户信息",
            type:'error'
          })
        }
        _this.getBalance(this.companyOrgs[this.index].id , this.selectedCustomerId);
        // 初始化签约信息
        _this.getSignInfo(this.companyOrgs[this.index].id , this.selectedCustomerId);
      }).catch(e => {
        console.log(e);
      });
    },
    customerChange(customerId){
      this.submitBillAmount = [];
      this.selectedCustomerId = customerId;
      for(let i = 0 ; i < this.customersOption.length ; i ++){
        if(this.customersOption[i].customerId === this.selectedCustomerId){
          // this.customerIndex = i;
          //直接保存客户编码和名称
          this.payParamCustomerNumber = this.customersOption[i].customer.number
          this.payParamCustomerName = this.customersOption[i].customer.name
          break;
        }
      }
      // this.getBalance(this.companyOrgs[this.index].id , this.selectedCustomerId);
      // console.log(this.companyOrgs[this.index].id);
      // console.log(this.selectedCustomerId);
      // this.getSignInfo(this.companyOrgs[this.index].id , this.selectedCustomerId);
      // this.getSubmitBillAmount(this.companyOrgs[this.index].id , this.selectedCustomerId);
    },
    serverSearch(query){
      //根据query重新初始化客户和账户余额
      let param = {};
      param.companyId = this.companyOrgs[this.index].id;
      param.customer = {};
      param.customer.name = query;
      this.queryCustomerAndBalance(param , false);
    },
    cardChange(){
      for(let i = 0 ; i < this.signInfoOption.length ; i ++){
        if(this.signInfoOption[i].id === this.selectedSignInfoId){
          this.signInfoIndex = i;
          break;
        }
      }
    },
    changeBill(){
      this.payInfo.payAmount = 0
      for (let i = 0; i< this.selectBill.length; i++){
        this.payInfo.payAmount = this.floatAdd(this.payInfo.payAmount, this.selectBill[i].TotalAmount);
      }
    },
    getBalance(companyId , customerId){
      let param = {};
      param.companyID = companyId;
      param.customerID = customerId;
      let _this = this;
      getBalanceAmount(param).then(
        res => {
          _this.payInfo.customerBalance = res.data.data.balance;
        }
      )
    },
    getSignInfo(companyId , customerId){
      //切换客户时，清除签约数据和金额
      this.signInfoOption = []
      this.selectedSignInfoId = ''
      this.payInfo.payAmount = 0
      let param = {};
      param.companyId = companyId;
      param.customerId = customerId;
      // 老osp同步数据,isSign均为 0
      param.isSign = 1;
      let _this = this;
      //console.log(param);
      QuerySignRecord(param).then(
        res => {
          //console.log(res)
          if(res.data.records.length > 0){
            for(let signRecord of res.data.records){
              let signInfo = {};
              signInfo.id = signRecord.id;
              signInfo.orderNo = signRecord.orderNo;
              signInfo.info = '卡号：' +
                (signRecord.cardLast4Number === null ? '':signRecord.cardLast4Number) + ' * 签约号：' + signRecord.orderNo;
              _this.signInfoOption.push(signInfo);
            }
            //默认选择首个签约记录
            if(_this.signInfoOption.length > 0){
              this.selectedSignInfoId = _this.signInfoOption[0].id;
            }else{
              this.$message({
                message:"未查询到客户签约信息",
                type:'error'
              })
            }
          }else{
            _this.signInfoOption = []
            _this.selectedSignInfoId = ''
          }
        }
      )
    },
    getSubmitBillAmount(companyId , customerId){
      let param = {};
      param.companyId = companyId;
      param.customerId = customerId;
      getSubmitBillAmount(param).then(
        res => {
          // console.log(res)
          // console.log(res.data.result)
          if(res.data.result !== undefined){
            this.submitBillAmount = res.data.result
          }
          // console.log(this.submitBillAmount)
        }
      )
    },
    selectCus(){
      this.disabledCus = !this.disabledCus
      this.payInfo.balance = ''
      //点击更换客户时清空数据
      if(!this.disabledCus){
        this.disabledCard = false
        this.selectedSignInfoId = ''
        this.submitBillAmount = []
        this.signInfoOption = []
        this.selectBill = []
        this.selectedCustomerId = ''
      }
      if(this.disabledCus && this.selectedCustomerId != null && this.selectedCustomerId !== ''){
        this.getBalance(this.companyOrgs[this.index].id , this.selectedCustomerId);
        this.getSignInfo(this.companyOrgs[this.index].id , this.selectedCustomerId);
        this.getSubmitBillAmount(this.companyOrgs[this.index].id , this.selectedCustomerId);
      }
    },
    selectCard(){
      this.disabledCard = !this.disabledCard
    },
    trustPay(){
      let _this = this;
      this.$refs['payInfo'].validate((valid) => {
        if(valid){
          if(_this.customersOption.length <= 0){
            this.$message({
              message:"请选择客户",
              type:'error'
            })
            return;
          }
          if(_this.signInfoOption.length <= 0){
            this.$message({
              message:"签约信息不能为空",
              type:'error'
            })
            return;
          }
          if(!_this.disabledCus){
            this.$message({
              message:"请锁定客户",
              type:'error'
            })
            return;
          }
          if(!_this.disabledCard){
            this.$message({
              message:"请锁定卡号",
              type:'error'
            })
            return;
          }
          let payParam = {};
          // payParam.customerId = _this.customersOption[_this.customerIndex].customer.id;
          // payParam.customerName = _this.customersOption[_this.customerIndex].customer.name;
          // payParam.customerNumber = _this.customersOption[_this.customerIndex].customer.number;
          // payParam.agentSignNo = _this.signInfoOption[_this.signInfoIndex].orderNo;
          payParam.customerId = _this.selectedCustomerId
          payParam.customerNumber = _this.payParamCustomerNumber
          payParam.customerName = _this.payParamCustomerName
          payParam.agentSignNo = _this.signInfoOption[_this.signInfoIndex].orderNo;
          payParam.name = _this.currentUser.person.name;
          payParam.salePersonId = _this.currentUser.person.id
          payParam.saleCompanyId = _this.companyOrgs[_this.index].id

          // console.log(this.payInfo.payAmount)
          let accountMoney = this.payInfo.payAmount.toString().match(/\d+\.?\d{0,2}/, '')
          if (accountMoney == null || accountMoney[0] === '' || accountMoney <= 0) {
            this.$modal.msgWarning("请输入付款金额")
            return
          }
          payParam.accountMoney = accountMoney[0];
          //存储发货公司
          payParam.reposCompanyId = _this.companyOrgs[_this.index].id;
          payParam.reposCompanyName = _this.companyOrgs[_this.index].name;
          //存储付款公司
          payParam.companyId = _this.companyOrgs[_this.index].id;
          payParam.companyName = _this.companyOrgs[_this.index].name;
          //设置支付方式 1：internet网络接入 2：手机网络接入
          payParam.frontPayType = 1;
          //pc端付款
          payParam.payType = 'ABC_AUTH_PAY'

          // console.log(payParam);
          this.loading = true;
          abcTrustPay(payParam).then( res => {
            //console.log(res)
            if(res.code === 200){
              _this.$message({
                message:"授权支付扣款成功",
                type:'success'
              });
              //扣款成功重新获取余额
              // _this.$alert('客户<'+payParam.customerName+'>已成功支付<'+accountMoney+'>元，客户余额<'+_this.floatAdd(_this.payInfo.customerBalance,payParam.accountMoney)+'>元！', '扣款成功提示', {
              //   confirmButtonText: '确定',
              //   callback: action => {}
              // });
              _this.payInfo.balance = payParam.customerName + "：" + this.floatAdd(this.payInfo.customerBalance,payParam.accountMoney)
              //扣款成功时，清除客户信息、签约数据和金额
              _this.signInfoOption = []
              _this.submitBillAmount = []
              _this.selectBill = []
              _this.selectedCustomerId = ''
              _this.selectedSignInfoId = ''
              _this.payInfo.payAmount = 0
              _this.payInfo.customerBalance = 0
              _this.disabledCus = false
              _this.disabledCard = false
              _this.payInfo.orderNo = res.data;
              _this.refresh();
            }
          }).finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 2000)
          });
        }else{
          _this.$message({
            message:"缺少必填信息",
            type:'error'
          })
          this.loading = false;
        }
      })
    },
    //小数加法
    floatAdd(a,b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, Math.max(m, n)); //将数字转换为整数的最大倍数
      return (this.floatMul(a, maxInt) + this.floatMul(b, maxInt)) / maxInt;
    },
    //小数乘法
    floatMul(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, m + n); //将数字转换为整数的最大倍数
      return Number(d.replace(".", "")) * Number(e.replace(".", "")) / maxInt;
    },
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .div_right{
    margin: 10px 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .sp3{
    margin-left: 70px;
  }
  .note{
    margin-top: 30px;
    min-height: 90px;
    background: #f5f7fa;
    color: #ff5000;
    line-height: 30px;
  }
  .leftBill{
    margin-top: 20px;
  }
  .rightBill{
    margin: 20px 40px;
  }
  .checkbox{
    margin: 16px 0;
    font-size: 20px;
    display: block;
  }
  .but4{
    margin-left: 10px;
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    font-weight: 600;
    width: 140px;
  }
  .sp4{
    font-size: 14px;
    color: white;
    font-weight: bold;
  }
</style>
